import { useContext } from 'react';
import { UtmContext } from '.';

export function useUtmContext() {
  return useContext(UtmContext);
}
